import { render, staticRenderFns } from "./addTask.vue?vue&type=template&id=17848059&scoped=true&"
import script from "./addTask.vue?vue&type=script&lang=js&"
export * from "./addTask.vue?vue&type=script&lang=js&"
import style0 from "./addTask.vue?vue&type=style&index=0&id=17848059&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17848059",
  null
  
)

export default component.exports